import { content } from "../../config/content.js";
import {
  appRoute,
  serviceRoute,
  sectionId,
  getRouteInfo,
  DEFAULT_SERVICE_SLUG,
  publicAsset,
  pageRoute,
} from "../../config/paths.js";
import { getProductSideNav } from "../../config/productContent.js";

const logoMark = `<img class="nav__logo" src="${publicAsset("Taldel Black.png")}" alt="${content.brand}" width="120" height="28" decoding="async" />`;

const chevronDownIcon = `<svg class="nav__chevron" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const menuOpenIcon = `<svg class="nav__toggle-icon nav__toggle-icon--open" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
</svg>`;

const menuCloseIcon = `<svg class="nav__toggle-icon nav__toggle-icon--close" width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
</svg>`;

const SIDE_ICONS = {
  Company: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 20V8.5L12 4l8 4.5V20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.5 20v-6h5v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  Delivery: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M13 3l-1.5 6.5H18L10 21l1.5-6.5H6L13 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
  </svg>`,
  Reviews: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5.5 8.5h5v5.5c0 1.8-1.4 3.2-3.2 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.5 8.5h5v5.5c0 1.8-1.4 3.2-3.2 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  Teams: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="2.5" stroke="currentColor" stroke-width="1.6"/>
    <circle cx="16.5" cy="9" r="2" stroke="currentColor" stroke-width="1.6"/>
    <path d="M3.5 18.5c.6-2.8 2.8-4.2 5.5-4.2s4.9 1.4 5.5 4.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <path d="M14 14.5c1.7-.4 3.4.2 4.5 1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  FAQs: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"/>
    <path d="M9.6 9.4c.3-1.2 1.3-1.9 2.5-1.9 1.4 0 2.4.8 2.4 2.1 0 1.4-1.1 1.8-2 2.4-.7.5-1 .9-1 1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <circle cx="12" cy="16.6" r="0.85" fill="currentColor"/>
  </svg>`,
  Contact: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3.5" y="5.5" width="17" height="13" rx="2" stroke="currentColor" stroke-width="1.6"/>
    <path d="M4.5 8l7.5 5.5L19.5 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  "Web Development": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/>
    <path d="M3.5 9h17" stroke="currentColor" stroke-width="1.6"/>
    <path d="M8 13.5l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  Web: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/>
    <path d="M3.5 9h17" stroke="currentColor" stroke-width="1.6"/>
    <path d="M8 13.5l2 2 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  "Agentic AI": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6.2 6.2l2.1 2.1M15.7 15.7l2.1 2.1M17.8 6.2l-2.1 2.1M8.3 15.7l-2.1 2.1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  AI: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6.2 6.2l2.1 2.1M15.7 15.7l2.1 2.1M17.8 6.2l-2.1 2.1M8.3 15.7l-2.1 2.1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  "App Development": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="7" y="2.5" width="10" height="19" rx="2.4" stroke="currentColor" stroke-width="1.6"/>
    <path d="M10.5 18.2h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  Apps: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="7" y="2.5" width="10" height="19" rx="2.4" stroke="currentColor" stroke-width="1.6"/>
    <path d="M10.5 18.2h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  "UI/UX Design": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 7.5A3.5 3.5 0 017.5 4H12v16H7.5A3.5 3.5 0 014 16.5v-9z" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 4h4.5A3.5 3.5 0 0120 7.5v2A3.5 3.5 0 0116.5 13H12V4z" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 13h2.5a3.5 3.5 0 010 7H12v-7z" stroke="currentColor" stroke-width="1.6"/>
  </svg>`,
  "UI/UX": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 7.5A3.5 3.5 0 017.5 4H12v16H7.5A3.5 3.5 0 014 16.5v-9z" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 4h4.5A3.5 3.5 0 0120 7.5v2A3.5 3.5 0 0116.5 13H12V4z" stroke="currentColor" stroke-width="1.6"/>
    <path d="M12 13h2.5a3.5 3.5 0 010 7H12v-7z" stroke="currentColor" stroke-width="1.6"/>
  </svg>`,
  "Cyber Security": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3l7.5 3v6.2c0 4.6-3.1 7.8-7.5 8.8-4.4-1-7.5-4.2-7.5-8.8V6L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
    <path d="M9.2 12.1l2 2 3.8-3.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  Cyber: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 3l7.5 3v6.2c0 4.6-3.1 7.8-7.5 8.8-4.4-1-7.5-4.2-7.5-8.8V6L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
    <path d="M9.2 12.1l2 2 3.8-3.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  "Staff Augmentation": `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="2.5" stroke="currentColor" stroke-width="1.6"/>
    <path d="M4 18c.6-2.6 2.6-4 5-4s4.4 1.4 5 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <path d="M16 8h4M18 6v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
  Staff: `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="2.5" stroke="currentColor" stroke-width="1.6"/>
    <path d="M4 18c.6-2.6 2.6-4 5-4s4.4 1.4 5 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
    <path d="M16 8h4M18 6v4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
  </svg>`,
};

const DEFAULT_SIDE_ICON = `<svg class="nav__icon" width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/>
  <circle cx="12" cy="12" r="7.5" stroke="currentColor" stroke-width="1.6"/>
</svg>`;

function sideIconFor(label) {
  return SIDE_ICONS[label] || DEFAULT_SIDE_ICON;
}

const HOME_SECTION_TO_NAV = {
  hero: appRoute("hero"),
  manifesto: appRoute("manifesto"),
  numbers: appRoute("numbers"),
  testimonials: appRoute("testimonials"),
  advantage: appRoute("advantage"),
  team: appRoute("team"),
  faqs: appRoute("faqs"),
  contact: appRoute("contact"),
};

function renderDropdown(children) {
  return `
    <ul class="nav__dropdown">
      ${children
        .map(
          (child) => `
        <li>
          <a class="nav__dropdown-link" href="${child.href}" data-service-slug="${child.slug || ""}">
            ${child.label}
          </a>
        </li>
      `
        )
        .join("")}
    </ul>
  `;
}

function renderPrimaryItem(item, index) {
  if (item.children?.length) {
    return `
      <li class="nav__item nav__item--has-children" style="--nav-i: ${index}">
        <button type="button" class="nav__link nav__link--trigger" aria-expanded="false" aria-haspopup="true">
          <span class="nav__label">${item.label}</span>
          ${chevronDownIcon}
        </button>
        ${renderDropdown(item.children)}
      </li>
    `;
  }

  return `
    <li class="nav__item" style="--nav-i: ${index}">
      <a class="nav__link" href="${item.href}">
        <span class="nav__label">${item.label}</span>
      </a>
    </li>
  `;
}

function renderSideItem(item, index) {
  return `
    <li class="nav__item" style="--nav-i: ${index}">
      <a class="nav__link" href="${item.href}">
        ${sideIconFor(item.label)}
        <span class="nav__label">${item.label}</span>
      </a>
    </li>
  `;
}

function renderMobilePrimaryItem(item) {
  if (item.children?.length) {
    return `
      <li class="nav__mobile-item nav__mobile-item--has-children">
        <button type="button" class="nav__mobile-link nav__mobile-link--trigger" aria-expanded="false">
          <span class="nav__label">${item.label}</span>
          ${chevronDownIcon}
        </button>
        <ul class="nav__mobile-sub">
          ${item.children
            .map(
              (child) => `
            <li>
              <a class="nav__mobile-sublink" href="${child.href}" data-service-slug="${child.slug || ""}">
                ${child.label}
              </a>
            </li>
          `
            )
            .join("")}
        </ul>
      </li>
    `;
  }

  return `
    <li class="nav__mobile-item">
      <a class="nav__mobile-link" href="${item.href}">
        <span class="nav__label">${item.label}</span>
      </a>
    </li>
  `;
}

function getNavOffset() {
  const bar = document.querySelector(".nav__bar");
  if (bar) return bar.offsetHeight;
  const nav = document.querySelector(".nav");
  return nav ? Math.min(nav.offsetHeight, 96) : 72;
}

function getScrollY() {
  return window.scrollY || document.documentElement.scrollTop || 0;
}

function getSectionTop(section) {
  return section.getBoundingClientRect().top + getScrollY();
}

function clampScrollTop(top) {
  const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  return Math.min(maxScroll, Math.max(0, top));
}

/** Land product lanes so the sticky frame fills the area below the nav. */
export function getAnchorScrollTop(target) {
  if (!target) return 0;

  const nav = getNavOffset();
  const pin = target.hasAttribute("data-lane")
    ? target.querySelector(".product-showcase__lane-pin") || target
    : target.id === "numbers" || target.id === "contact" || target.id === "faqs"
      ? target.querySelector(".section__inner") || target
      : target;

  const alignTop = getSectionTop(pin) - nav;

  if (target.id === "numbers" || target.id === "team" || target.id === "contact") {
    const fitEl = target.id === "team" ? target : pin;
    const bottomGap = target.id === "numbers" ? 48 : 28;
    const alignBottom = getSectionTop(fitEl) + fitEl.offsetHeight + bottomGap - window.innerHeight;
    const top = Math.max(alignTop, alignBottom);
    return clampScrollTop(target.id === "numbers" ? top : top - 56);
  }

  return clampScrollTop(alignTop);
}

function getCenteredFocusBox(target) {
  if (target.id === "advantage") {
    const intro = target.querySelector(".advantage__intro");
    const firstCard = target.querySelector(".advantage__card");
    if (intro || firstCard) {
      const start = intro || firstCard;
      const end = firstCard || intro;
      const top = getSectionTop(start);
      return { top, height: getSectionTop(end) + end.offsetHeight - top };
    }
  }

  if (target.id === "approach") {
    const inner = target.querySelector(".section__inner") || target;
    return { top: getSectionTop(inner), height: inner.offsetHeight };
  }

  const el =
    target.id === "team" || target.id === "faqs"
      ? target
      : target.querySelector(".section__inner") || target;
  return { top: getSectionTop(el), height: el.offsetHeight };
}

function centerBoxInView(top, height, nav) {
  const available = Math.max(0, window.innerHeight - nav);
  if (height >= available) {
    return clampScrollTop(top - nav);
  }
  return clampScrollTop(top - nav - (available - height) / 2);
}

/** Center a section in the space below the nav. Tall sections stay top-aligned. */
export function getCenteredScrollTop(target) {
  if (!target) return 0;

  const nav = getNavOffset();
  const available = Math.max(0, window.innerHeight - nav);

  if (target.id === "advantage" || target.id === "approach") {
    const box = getCenteredFocusBox(target);
    return centerBoxInView(box.top, box.height, nav);
  }

  const el =
    target.id === "team" || target.id === "faqs"
      ? target
      : target.querySelector(".section__inner") || target;
  const top = getSectionTop(el);
  const height = el.offsetHeight;

  if (target.id === "faqs") {
    const inner = target.querySelector(".section__inner") || target;
    return clampScrollTop(getSectionTop(inner) - nav);
  }

  if (height >= available) {
    return getAnchorScrollTop(target);
  }

  return clampScrollTop(top - nav - (available - height) / 2);
}

function isCenteredSection(id) {
  return id === "advantage" || id === "approach";
}

export function scrollToPageSection(target, { behavior = "smooth" } = {}) {
  if (!target) return;
  const top = isCenteredSection(target.id)
    ? getCenteredScrollTop(target)
    : getAnchorScrollTop(target);
  window.scrollTo({ top, behavior });
}

function pathnameOf(href) {
  try {
    return new URL(href, window.location.origin).pathname.replace(/\/+$/, "") || "/";
  } catch {
    return "";
  }
}

function isSamePageHref(href) {
  if (!href || href.startsWith("mailto:") || href.startsWith("http")) return false;
  return pathnameOf(href) === pathnameOf(window.location.href);
}

export function createNav() {
  const { primary, side, cta } = content.nav;
  const nav = document.createElement("nav");
  nav.className = "nav";
  const route = getRouteInfo();
  const onHome = route.page === "home";
  const onProduct = route.page === "product";
  const sideItems = onProduct ? getProductSideNav() : side;
  const showSideRail = onHome || onProduct;

  nav.innerHTML = `
    <div class="nav__bar">
      <a class="nav__brand" href="${appRoute("hero")}" aria-label="${content.brand}">
        ${logoMark}
      </a>

      <div class="nav__center">
        <ul class="nav__links nav__links--primary">
          ${primary.map(renderPrimaryItem).join("")}
        </ul>
      </div>

      <div class="nav__side nav__side--right">
        <a class="nav__cta nav__cta--desktop" href="${cta.href}" data-nav-auth="register">${cta.label}</a>
        <button
          type="button"
          class="nav__toggle"
          aria-expanded="false"
          aria-controls="nav-mobile-panel"
          aria-label="Open menu"
        >
          ${menuOpenIcon}
          ${menuCloseIcon}
        </button>
      </div>
    </div>

    <div class="nav__mobile" id="nav-mobile-panel" hidden>
      <div class="nav__mobile-panel">
        <ul class="nav__mobile-list">
          ${primary.map(renderMobilePrimaryItem).join("")}
        </ul>
        <div class="nav__mobile-auth">
          <a class="nav__cta" href="${cta.href}" data-nav-auth="register">${cta.label}</a>
        </div>
      </div>
    </div>

    ${
      showSideRail
        ? `
    <div class="nav__rail" aria-label="On this page">
      <ul class="nav__links nav__links--side">
        ${sideItems.map(renderSideItem).join("")}
      </ul>
    </div>
    `
        : ""
    }
  `;

  bindDropdowns(nav);
  bindMobileMenu(nav);

  // Reparent outside .content-layer so overflow-x: clip doesn't break position:fixed on mobile.
  queueMicrotask(() => {
    const app = document.getElementById("app");
    if (app && nav.parentElement && nav.parentElement !== app) {
      app.appendChild(nav);
    }
  });

  return nav;
}

function setMobileMenuOpen(nav, open) {
  const toggle = nav.querySelector(".nav__toggle");
  const panel = nav.querySelector(".nav__mobile");
  if (!toggle || !panel) return;

  nav.classList.toggle("is-mobile-open", open);
  toggle.setAttribute("aria-expanded", open ? "true" : "false");
  toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  panel.hidden = !open;
  document.body.classList.toggle("nav-mobile-lock", open);

  if (!open) {
    nav.querySelectorAll(".nav__mobile-item--has-children.is-open").forEach((item) => {
      item.classList.remove("is-open");
      item.querySelector(".nav__mobile-link--trigger")?.setAttribute("aria-expanded", "false");
    });
  }
}

function bindMobileMenu(nav) {
  const toggle = nav.querySelector(".nav__toggle");
  const panel = nav.querySelector(".nav__mobile");
  if (!toggle || !panel) return;

  toggle.addEventListener("click", (event) => {
    event.stopPropagation();
    setMobileMenuOpen(nav, !nav.classList.contains("is-mobile-open"));
  });

  panel.querySelectorAll(".nav__mobile-link--trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const item = trigger.closest(".nav__mobile-item--has-children");
      if (!item) return;
      const open = item.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");

      panel.querySelectorAll(".nav__mobile-item--has-children").forEach((other) => {
        if (other === item) return;
        other.classList.remove("is-open");
        other.querySelector(".nav__mobile-link--trigger")?.setAttribute("aria-expanded", "false");
      });
    });
  });

  panel.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMobileMenuOpen(nav, false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && nav.classList.contains("is-mobile-open")) {
      setMobileMenuOpen(nav, false);
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= 1024 && nav.classList.contains("is-mobile-open")) {
      setMobileMenuOpen(nav, false);
    }
  });
}

function setDesktopDropdownOpen(nav, item, open) {
  const trigger = item.querySelector(".nav__link--trigger");
  item.classList.toggle("is-open", open);
  trigger?.setAttribute("aria-expanded", open ? "true" : "false");

  if (!open) return;

  nav.querySelectorAll(".nav__item--has-children").forEach((other) => {
    if (other === item) return;
    other.classList.remove("is-open");
    other.querySelector(".nav__link--trigger")?.setAttribute("aria-expanded", "false");
  });
}

function bindDropdowns(nav) {
  nav.querySelectorAll(".nav__item--has-children").forEach((item) => {
    const trigger = item.querySelector(".nav__link--trigger");
    if (!trigger) return;

    let closeTimer = 0;
    const hoverDesktop = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    const openMenu = () => {
      window.clearTimeout(closeTimer);
      setDesktopDropdownOpen(nav, item, true);
    };

    const closeMenu = () => {
      window.clearTimeout(closeTimer);
      setDesktopDropdownOpen(nav, item, false);
    };

    item.addEventListener("pointerenter", () => {
      if (!hoverDesktop()) return;
      openMenu();
    });

    item.addEventListener("pointerleave", () => {
      if (!hoverDesktop()) return;
      closeTimer = window.setTimeout(closeMenu, 140);
    });

    trigger.addEventListener("focus", openMenu);

    item.addEventListener("focusout", (event) => {
      if (item.contains(event.relatedTarget)) return;
      closeTimer = window.setTimeout(closeMenu, 140);
    });

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      if (hoverDesktop()) {
        openMenu();
        return;
      }
      setDesktopDropdownOpen(nav, item, !item.classList.contains("is-open"));
    });
  });

  document.addEventListener("click", (event) => {
    if (nav.contains(event.target)) return;
    nav.querySelectorAll(".nav__item--has-children.is-open").forEach((item) => {
      setDesktopDropdownOpen(nav, item, false);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    nav.querySelectorAll(".nav__item--has-children.is-open").forEach((item) => {
      setDesktopDropdownOpen(nav, item, false);
    });
  });
}

export function bindNav(nav, options = {}) {
  const route = getRouteInfo();
  const page = options.page || route.page;
  const serviceSlug = options.serviceSlug || route.slug || DEFAULT_SERVICE_SLUG;
  const sectionMap = options.sectionMap || HOME_SECTION_TO_NAV;
  const pageHref = page === "service" ? serviceRoute(serviceSlug) : appRoute("hero");
  const insightsHref =
    page === "service" ? serviceRoute(serviceSlug, "insights") : appRoute("testimonials");

  const resolveHref = (sectionKey) => sectionMap[sectionKey] || pageHref;

  // Resolve mapped ids (sections and product lanes) so in-page anchors work beyond <section>.
  const pageSections = Object.keys(sectionMap)
    .map((id) => document.getElementById(id))
    .filter(Boolean)
    .sort((a, b) => getSectionTop(a) - getSectionTop(b));

  const sectionRatios = new Map();
  let activeHref = "";

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        sectionRatios.set(entry.target.id, entry.isIntersecting ? entry.intersectionRatio : 0);
      });
    },
    {
      root: null,
      rootMargin: `-${getNavOffset()}px 0px -40% 0px`,
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    }
  );

  pageSections.forEach((section) => observer.observe(section));

  const resolveActiveHref = () => {
    const scrollY = getScrollY();
    const viewHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;

    if (page === "service" && scrollY + viewHeight >= scrollHeight - 4) {
      return sectionMap.contact || insightsHref;
    }

    if (page === "product" && scrollY + viewHeight >= scrollHeight - 4) {
      return sectionMap.contact || pageRoute("our-portfolios", "contact");
    }

    if (page === "home" && scrollY + viewHeight >= scrollHeight - 4) {
      return appRoute("contact");
    }

    // Prefer the product lane whose sticky pin is currently in focus.
    if (page === "product") {
      const lanes = pageSections.filter((el) => el.hasAttribute("data-lane"));
      if (lanes.length) {
        const focusY = viewHeight * 0.35;
        let bestLane = null;
        let bestDist = Infinity;
        for (const lane of lanes) {
          const pin = lane.querySelector(".product-showcase__lane-pin") || lane;
          const rect = pin.getBoundingClientRect();
          if (rect.bottom < getNavOffset() || rect.top > viewHeight) continue;
          const mid = (rect.top + Math.min(rect.bottom, viewHeight)) / 2;
          const dist = Math.abs(mid - focusY);
          if (dist < bestDist) {
            bestDist = dist;
            bestLane = lane;
          }
        }
        if (bestLane?.id && sectionMap[bestLane.id]) {
          return resolveHref(bestLane.id);
        }
      }
    }

    let bestId = "";
    let bestRatio = 0;

    for (const [id, ratio] of sectionRatios) {
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestId = id;
      }
    }

    if (bestId && bestRatio > 0) {
      return resolveHref(bestId);
    }

    const marker = scrollY + getNavOffset() + 1;
    let activeSectionId = pageSections[0]?.id ?? (page === "service" ? "banner" : "hero");

    for (const section of pageSections) {
      if (getSectionTop(section) <= marker) {
        activeSectionId = section.id;
      }
    }

    return resolveHref(activeSectionId);
  };

  const updateNavActive = () => {
    const href = resolveActiveHref();
    if (!href || href === activeHref) return;
    activeHref = href;
    setActiveLink(nav, href, page, serviceSlug);
  };

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", (event) => {
      const href = link.getAttribute("href");
      if (!href || href.startsWith("mailto:") || href.startsWith("http")) return;

      const targetId = sectionId(href);
      if (!targetId || !isSamePageHref(href)) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      scrollToPageSection(target);
      history.pushState(null, "", href);
      activeHref = href;
      setActiveLink(nav, href, page, serviceSlug);
    });
  });

  document.addEventListener("click", (event) => {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const link = event.target.closest("a[href]");
    if (!link || nav.contains(link)) return;

    const href = link.getAttribute("href");
    if (!href || href.startsWith("mailto:") || href.startsWith("http")) return;

    const targetId = sectionId(href);
    if (!targetId || !isSamePageHref(href)) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    scrollToPageSection(target);
    history.pushState(null, "", href);
    activeHref = href;
    setActiveLink(nav, href, page, serviceSlug);
  });

  window.addEventListener("resize", updateNavActive);
  updateNavActive();

  return updateNavActive;
}

function setActiveLink(nav, href, page = "home", serviceSlug = DEFAULT_SERVICE_SLUG) {
  const activeSection = sectionId(href);
  const route = getRouteInfo();
  const productPath = pathnameOf(pageRoute("our-portfolios"));
  const signupPath = pathnameOf(pageRoute("signup"));
  const loginPath = pathnameOf(pageRoute("login"));

  const onProductPage = page === "product" || page === "product-detail" || route.page === "product";
  const onProductDetail = page === "product-detail" || route.page === "product-detail";
  const onInsightDetail = page === "insight-detail" || route.page === "insight-detail";
  const onInsightsPage = page === "insights" || route.page === "insights";
  const onServicePage = page === "service" || route.page === "service";
  const onServiceFamily = onServicePage;
  const onAboutPage = page === "about" || route.page === "about";
  const aboutPath = pathnameOf(pageRoute("about-us"));
  const insightsPath = pathnameOf(pageRoute("insights"));

  const linkLabel = (link) =>
    (link.querySelector(".nav__label")?.textContent || link.textContent || "").trim();

  // Top bar primary links
  nav.querySelectorAll(".nav__links--primary .nav__link:not(.nav__link--trigger)").forEach((link) => {
    const linkHref = link.getAttribute("href") || "";
    const linkPath = pathnameOf(linkHref);
    const linkSection = sectionId(linkHref);
    const label = linkLabel(link);

    let isActive = false;

    if (onAboutPage) {
      isActive = label === "About" || linkPath === aboutPath;
    } else if (onInsightsPage || onInsightDetail) {
      isActive = label === "Insights" || linkPath === insightsPath;
    } else if (onProductPage || onProductDetail) {
      isActive = label === "Our Portfolios" || (linkPath === productPath && !linkSection);
    } else if (page === "signup") {
      isActive = linkPath === signupPath;
    } else if (page === "login") {
      isActive = linkPath === loginPath;
    }

    link.classList.toggle("nav__link--active", isActive);
    if (isActive) link.setAttribute("aria-current", "page");
    else link.removeAttribute("aria-current");
  });

  // Mobile drawer links
  nav.querySelectorAll(".nav__mobile-link:not(.nav__mobile-link--trigger)").forEach((link) => {
    const linkHref = link.getAttribute("href") || "";
    const linkPath = pathnameOf(linkHref);
    const linkSection = sectionId(linkHref);
    const label = linkLabel(link);

    let isActive = false;

    if (onAboutPage) {
      isActive = label === "About" || linkPath === aboutPath;
    } else if (onInsightsPage || onInsightDetail) {
      isActive = label === "Insights" || linkPath === insightsPath;
    } else if (onProductPage || onProductDetail) {
      if (linkSection) {
        isActive = isSamePageHref(linkHref) && linkSection === activeSection;
      } else {
        isActive = label === "Our Portfolios" || linkPath === productPath;
      }
    } else if (page === "signup") {
      isActive = linkPath === signupPath;
    } else if (page === "login") {
      isActive = linkPath === loginPath;
    } else if (page === "home") {
      isActive = isSamePageHref(linkHref) && linkSection === activeSection;
    }

    link.classList.toggle("nav__mobile-link--active", isActive);
    if (isActive) link.setAttribute("aria-current", "page");
    else link.removeAttribute("aria-current");
  });

  // Side rail — landing sections or product service lanes
  nav.querySelectorAll(".nav__links--side .nav__link").forEach((link) => {
    const linkHref = link.getAttribute("href") || "";
    const linkSection = sectionId(linkHref);
    const isActive =
      (page === "home" || page === "product") &&
      isSamePageHref(linkHref) &&
      linkSection === activeSection;

    link.classList.toggle("nav__link--active", isActive);
    if (isActive) link.setAttribute("aria-current", "page");
    else link.removeAttribute("aria-current");
  });

  const servicesItem = nav.querySelector(".nav__item--has-children");
  if (servicesItem) {
    const trigger = servicesItem.querySelector(".nav__link--trigger");
    trigger?.classList.toggle("nav__link--active", onServiceFamily);
    if (onServiceFamily) trigger?.setAttribute("aria-current", "true");
    else trigger?.removeAttribute("aria-current");

    servicesItem.querySelectorAll(".nav__dropdown-link").forEach((link) => {
      const slug = link.getAttribute("data-service-slug");
      const isActive = onServiceFamily && slug === serviceSlug;
      link.classList.toggle("nav__dropdown-link--active", isActive);
      if (isActive) link.setAttribute("aria-current", "page");
      else link.removeAttribute("aria-current");
    });
  }

  const mobileServices = nav.querySelector(".nav__mobile-item--has-children");
  if (mobileServices) {
    const trigger = mobileServices.querySelector(".nav__mobile-link--trigger");
    trigger?.classList.toggle("nav__mobile-link--active", onServiceFamily);
    mobileServices.querySelectorAll(".nav__mobile-sublink").forEach((link) => {
      const slug = link.getAttribute("data-service-slug");
      const isActive = onServiceFamily && slug === serviceSlug;
      link.classList.toggle("nav__mobile-sublink--active", isActive);
      if (isActive) link.setAttribute("aria-current", "page");
      else link.removeAttribute("aria-current");
    });
  }

  const brand = nav.querySelector(".nav__brand");
  if (brand) {
    const isHome = page === "home" && (activeSection === "hero" || !activeSection);
    brand.classList.toggle("nav__brand--active", isHome);
    if (isHome) brand.setAttribute("aria-current", "page");
    else brand.removeAttribute("aria-current");
  }

  nav.querySelectorAll(".nav__cta[data-nav-auth]").forEach((btn) => {
    const kind = btn.getAttribute("data-nav-auth");
    const isActive =
      (kind === "login" && page === "login") ||
      (kind === "register" && page === "signup");
    btn.classList.toggle("nav__cta--active", isActive);
    if (isActive) btn.setAttribute("aria-current", "page");
    else btn.removeAttribute("aria-current");
  });
}
